export class SessionStorageService {

    set(key: any, value: any): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    get(key: any): any {
        return JSON.parse(sessionStorage.getItem(key));
    }

    delete(key: any): void {
        sessionStorage.removeItem(key);
    }

    clear(): void {
        sessionStorage.clear();
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/session-storage.service.ts